import { Card, Flex, Typography } from "antd";
import React from "react";

import canlendarTick from "../../../../assets/icons/calendar-tick.svg";
import walletMoney from "../../../../assets/icons/wallet-money.svg";
import strongbox from "../../../../assets/icons/strongbox.svg";

export default function TreatmentsStatistics() {
  const testQuantities = [
    { title: "Total Revenue", value: "$75,000", icon: strongbox, iconAlt: "pulse" },
    { title: " Total AR", value: "$50,550", icon: walletMoney, iconAlt: "wallet" },
    { title: "Avg Days to Pay", value: 123, icon: canlendarTick, iconAlt: "calendare-tick" },
  ];

  return (
    <Flex vertical gap={10} style={{ width: "50%" }}>
      {testQuantities.map((item) => (
        <Card size="small" style={{ padding: 5 }}>
          <Flex align="center" justify="space-between">
            <Flex vertical gap={5}>
              <Typography.Title level={4} style={{ marginBottom: 0 }}>
                {item.title}
              </Typography.Title>
              <Typography.Title level={4} style={{ marginTop: 0, color: "#6b43b5" }}>
                {item.value}
              </Typography.Title>
            </Flex>

            <Flex align="center" justify="center" style={{ width: 73, height: 73, borderRadius: 100, backgroundColor: "#7F59CE" }}>
              <img src={item.icon} alt={item.iconAlt} />
            </Flex>
          </Flex>
        </Card>
      ))}
    </Flex>
  );
}
